<template>
  <IconButton @click.stop="addRepeaterModal?.$el?.present()" icon="icon-plus"></IconButton>
  <IonModal ref="addRepeaterModal">
    <IonHeader class="ion-no-border px-[10px] bg-white">
      <IonToolbar color="white" class="border-b-2 border-gray-300">
        <IonTitle color="medium">
          <div class="flex items-center"><i class="icon-repeater mr-2"></i>Add Repeater</div>
        </IonTitle>
        <IonButtons slot="end">
          <IconButton icon="icon-x" @click="addRepeaterModal?.$el?.dismiss()"></IconButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>
    <IonContent>
      <IonList inset>
        <SerialNumberInput
          v-model:serial="repeaterSerial.value"
          :state="repeaterSerial.state"
          :errors="repeaterSerial.errors"
          gray
          id="addRepeaterSNInput"
        ></SerialNumberInput>
      </IonList>
    </IonContent>
    <IonFooter class="ion-no-border px-[10px] pb-2 bg-white">
      <IonToolbar color="white" class="border-t-2 border-gray-300">
        <PrimaryBlockButton @click="save()" :disabled="!repeaterSerial.value || !repeaterSerial.valid"
          >Save Repeater</PrimaryBlockButton
        >
      </IonToolbar>
    </IonFooter>
  </IonModal>
</template>

<script setup lang="ts">
import IconButton from '@/components/forms/IconButton.vue';
import PrimaryBlockButton from '@/components/forms/PrimaryBlockButton.vue';
import SerialNumberInput from '@/components/forms/serial-input/SerialNumberInput.vue';
import { useFormControl } from '@/composables/use-form-control';
import { useToast } from '@/composables/use-toast';
import { RequiredFieldValidator } from '@/composables/validators/required';
import {
  DeviceFamilyValidator,
  NoThirdPartyValidator,
  UnprogrammedDeviceValidator,
} from '@/composables/validators/serial-form-control-validators';
import { useSelectedProperty } from '@/stores/selected-property.store';
import {
  createAnimation,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonList,
  IonModal,
  IonTitle,
  IonToolbar,
  useIonRouter,
} from '@ionic/vue';
import { RepeaterDeviceFamilies } from 'common';
import { useTemplateRef, watchEffect } from 'vue';

const addRepeaterModal = useTemplateRef('addRepeaterModal');

const repeaterSerial = useFormControl(() => undefined, {
  validators: [RequiredFieldValidator(), NoThirdPartyValidator(), DeviceFamilyValidator(RepeaterDeviceFamilies)],
  asyncValidators: [UnprogrammedDeviceValidator()],
});
const selectedProperty = useSelectedProperty();
const { successToast, errorToast } = useToast();
const router = useIonRouter();

async function save() {
  if (repeaterSerial.valid && repeaterSerial.value) {
    const repeaterId: number = repeaterSerial.value;
    const propertyId = selectedProperty.property?._id;
    const { success, error } = await selectedProperty.addRepeater(repeaterId);
    if (success) {
      successToast(`${repeaterId.toString(16).toUpperCase()} programmed!`);
      addRepeaterModal.value?.$el?.dismiss();
      setTimeout(() => {
        if (propertyId) {
          router.push(`/repeater/${propertyId}/${repeaterId}`);
        }
      }, 300);
    } else if (error) {
      errorToast(error);
    }
  }
}
</script>

<style scoped></style>
